import { render } from "./FamilyTree.vue?vue&type=template&id=6c912e6f"
import script from "./FamilyTree.vue?vue&type=script&lang=js"
export * from "./FamilyTree.vue?vue&type=script&lang=js"

import "./FamilyTree.vue?vue&type=style&index=0&id=6c912e6f&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__